import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import pt from 'vuetify/es5/locale/pt'
import 'material-design-icons-iconfont'
import '@mdi/font/css/materialdesignicons.css'; // Importa os ícones MDI


Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    themes: {
      light: {
        //#ee44aa
        primary: '#ee44aa',
        secondary: '#424242',
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107'
      }
    }
  },
  lang: {
    locales: { pt },
    current: 'pt'
  },
  icons: {
    iconfont: 'mdi'
  }
})
